import axios from "../../../../../axios";
import Cookies from "js-cookie";

export const GetAllBackOutCandidates = async () => {
  const token = Cookies.get("employeeToken");

  return axios.post("/api/Candidate/GetBackOutCandidates", {
    token,
  });
};
